<template>
  <div class="batch-summary-footer" :class="{ 'is-empty': !summary.skuCount }">
    <div class="batch-summary-footer__title">
      <i class="el-icon-s-claim" />
      {{ $l('label_selected_summary') || '已选汇总' }}
    </div>
    <div class="batch-summary-footer__items">
      <div class="batch-summary-footer__item">
        <span>{{ $l('label_sku_count') || 'SKU数量' }}</span>
        <strong>{{ summary.skuCount }}</strong>
      </div>
      <div class="batch-summary-footer__item">
        <span>{{ $l('form_label_totalCtnQty') || '总箱数' }}</span>
        <strong>{{ summary.totalCtnQty }}</strong>
      </div>
      <div class="batch-summary-footer__item">
        <span>{{ $l('label_total_volume') || '总体积' }}</span>
        <strong>{{ summary.totalVolume }} m³</strong>
      </div>
      <div v-if="showWeight" class="batch-summary-footer__item">
        <span>{{ $l('label_total_gross_weight') || '总毛重' }}</span>
        <strong>{{ summary.totalWeight }} kg</strong>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checkedSummary: {
      type: Object,
      default: () => ({
        skuCount: 0,
        totalCtnQty: 0,
        totalVolume: 0,
        totalWeight: 0,
      }),
    },
    showWeight: { type: Boolean, default: false },
  },
  computed: {
    summary() {
      return {
        skuCount: this.checkedSummary.skuCount || 0,
        totalCtnQty: this.checkedSummary.totalCtnQty || 0,
        totalVolume: this.checkedSummary.totalVolume || 0,
        totalWeight: this.checkedSummary.totalWeight || 0,
      }
    },
  },
}
</script>

<style scoped>
.batch-summary-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 34px;
  padding: 6px 10px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.batch-summary-footer.is-empty {
  color: #94a3b8;
}

.batch-summary-footer__title {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  font-weight: 600;
  color: #475569;
}

.batch-summary-footer.is-empty .batch-summary-footer__title {
  color: #94a3b8;
}

.batch-summary-footer__items {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  min-width: 0;
  flex-wrap: wrap;
}

.batch-summary-footer__item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.batch-summary-footer__item strong {
  color: #1e293b;
  font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;
  font-size: 12px;
}

.batch-summary-footer.is-empty .batch-summary-footer__item strong {
  color: #94a3b8;
}
</style>
